import { request } from '../client';

export const listCategories = () => request('/categories');

export const listProducts = (params) => request('/products', { params });

export const getBestOffers = (limit) => request('/products/best-offers', { params: { limit } });

export const getProduct = (idOrSku) => request(`/products/${encodeURIComponent(idOrSku)}`);

export const listActiveSales = () => request('/sales/active');
